import React, { useContext } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "GlobalContext";
import {
  MemberCardWrapper,
  Photo,
  Image,
  Content,
  Name,
  Occupation,
  BioHint,
} from "./styles/MemberCardStyles";

// featured: the president's card, which opens the biography on click.
const MemberCard = ({ featured, data, onClick }) => {
  const { currentLang } = useContext(GlobalContext);
  const { nomEtPrenom, fonction1, fonction2, image } = data;

  return (
    <MemberCardWrapper className="member-card" onClick={onClick}>
      <Photo>
        <Image src={image.sourceUrl} alt={nomEtPrenom} />
      </Photo>
      <Content featured={featured}>
        <Name featured={featured}>{nomEtPrenom}</Name>
        <Occupation featured={featured}>
          {fonction1} {fonction2}
        </Occupation>
        {featured && (
          <BioHint>
            {currentLang === "en" ? "Read the biography" : "Lire la biographie"}
            <span aria-hidden="true">+</span>
          </BioHint>
        )}
      </Content>
    </MemberCardWrapper>
  );
};

MemberCard.propTypes = {
  featured: PropTypes.bool,
  onClick: PropTypes.func,
};

MemberCard.defaultProps = {
  featured: false,
  onClick: () => {},
};

export default MemberCard;
